import { render, staticRenderFns } from "./externalcontacts.vue?vue&type=template&id=6a0fc7aa&scoped=true&"
import script from "./externalcontacts.vue?vue&type=script&lang=ts&"
export * from "./externalcontacts.vue?vue&type=script&lang=ts&"
import style0 from "./externalcontacts.vue?vue&type=style&index=0&id=6a0fc7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0fc7aa",
  null
  
)

export default component.exports